import React from 'react'
import { useState,useEffect } from 'react';

const Item = ({Obj,setID,setName,setSizes,setRemarks,setSave}) => {
    const [sizes,setSize]=useState();
    useEffect(()=>{
      let sizesl = "|";
      for (let index = 0; index < Obj.sizes.length; index++) {
        const element = Obj.sizes[index];
        sizesl = sizesl+ " " + element + " |";
      }
      setSize(sizesl);
    },[Obj.sizes])
    const EditFunction = ()=>{
        let sizes = [];
        for (let index = 0; index < Obj.sizeList.length; index++) {
            const element = Obj.sizeList[index];
            sizes.push(element.name);
        }
        setID(Obj.id); setName(Obj.name); setRemarks(Obj.remarks); setSizes(sizes); setSave('Update');
    }
  return (
    <tr className='form_item_row_container discription' onClick={EditFunction} style={{cursor:"pointer"}}>
      <td className='form_item_row_container_item' style={{width:'30%'}}>
        <p>{Obj.name}</p>
      </td>
      <td className='form_item_row_container_item' style={{width:'70%'}}>
        <p>{sizes}</p>
      </td>
    </tr>
  )
}

export default Item
